export default "__VITE_ASSET__0SSqSTBl__"